/** 首页 · 核心业绩概况 mock 数据（与 UI 稿字段一致） */

const REGION_RATES = [
  { name: '华东大区', rate: 80.12 },
  { name: '华北大区', rate: 80.12 },
  { name: '西北大区', rate: 80.12 },
  { name: '西南大区', rate: 80.12 },
  { name: '华中大区', rate: 80.12 },
  { name: '华南大区', rate: 80.12 },
  { name: '山东特区', rate: 80.12 },
]

function dealerGoal(key, title, icon, target, unit, completed, rate) {
  return {
    key,
    title,
    icon,
    target,
    unit,
    completed,
    rate,
    showRegions: true,
    regions: REGION_RATES.map(r => ({ ...r })),
  }
}

function directGoal(key, title, icon, target, unit, completed, rate) {
  return {
    key,
    title,
    icon,
    target,
    unit,
    completed,
    rate,
    showRegions: false,
  }
}

export function emptyCoreDashboardData() {
  return {
    dealerSection: {
      title: '本年度——经销业务目标',
      goals: [],
    },
    directSection: {
      title: '本年度——直营业务目标',
      goals: [],
    },
    ecommerceSection: {
      title: '本年度——数字营销业务目标',
      goals: [],
    },
  }
}

/** @deprecated 对接 GET /dashboard/core/overview 后仅作结构参考 */
export const coreDashboardData = {
  dealerSection: {
    title: '本年度——经销业务目标',
    goals: [
      dealerGoal('sales', '销售目标', 'goalTarget', 50000, '元', 40000, 80.12),
      dealerGoal('lease', '租赁新装机目标', 'goalLease', 50000, '台', 40000, 80.12),
      dealerGoal('buyout', '买断装机目标', 'goalBuyout', 50000, '台', 40000, 80.12),
      dealerGoal('collection', '回款目标', 'goalCollection', 50000, '元', 40000, 80.12),
      dealerGoal('recruit', '招商目标', 'goalRecruit', 50000, '个', 40000, 80.12),
    ],
  },
  directSection: {
    title: '本年度——直营业务目标',
    goals: [
      directGoal('sales', '销售目标', 'goalTarget', 50000, '元', 40000, 80.12),
      directGoal('lease', '租赁新装机目标', 'goalLease', 50000, '台', 40000, 80.12),
      directGoal('buyout', '买断装机目标', 'goalBuyout', 50000, '台', 40000, 80.12),
      directGoal('collection', '回款目标', 'goalCollection', 50000, '元', 40000, 80.12),
    ],
  },
  ecommerceSection: {
    title: '本年度——数字营销业务目标',
    goals: [
      directGoal('sales', '销售目标', 'goalTarget', 50000, '元', 40000, 80.12),
      directGoal('lease', '租赁装机目标', 'goalLease', 50000, '台', 40000, 80.12),
      directGoal('buyout', '买断装机目标', 'goalBuyout', 50000, '台', 40000, 80.12),
    ],
  },
}
